
import { Vue, Component, toNative } from 'vue-facing-decorator';
import EmailBranding from '@/components/OrganizationalSettings/EmailBranding/EmailBranding.vue';

@Component({
  components: {
    EmailBranding,
  },
})
class OrganizationalSettings extends Vue {
}
export default toNative(OrganizationalSettings);
